export default [
    "24 24",
    '<circle cx="12" cy="12" r="4" fill="var(--ci-primary-color, currentColor)"/>'
]
